import {inject, Injectable} from '@angular/core';
import {CreateDeclarationParams, DeclarationData, DeclarationFile} from "../types/declaration-modal.types";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {declarationResourceType} from "../configs/declaration-modal-config";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class DeclarationModalService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public createDeclaration(createDeclarationParams: CreateDeclarationParams): Promise<DeclarationData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateDeclarationParams, DeclarationData>(createDeclarationParams, declarationResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<DeclarationFile>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<DeclarationFile>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
